import React from 'react';
import {
  TableCard, Typography, Filter, Box,
} from 'vindi-ds-components';
import { useNavigate } from 'react-router-dom';
import useFilter from '../hooks/useFilter';
import priceFormat from '../utils/priceFormat';

function Info({ label, value }) {
  return (
    <Box display='flex' mb='4px'>
      <Typography variant='caption' color='neutral[500]'>{label}&nbsp;</Typography>
      <Typography variant='caption' color='neutral[800]'>{value}</Typography>
    </Box>
  );
}

const ProductItem = ({ product }) => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/admin/products/${id}`);
  };

  return (
    <TableCard.Container
      data-testid='product-table-card'
      onClick={() => handleClick(product.id)}
    >
      <TableCard.TextWithAction
        label='Nome'
        value={product.name}
      />
      <Box p={1}>
        <Info label='Tipo:' value={product.pricing_schema.schema_type} />
        <Info label='Preço:' value={priceFormat(product.pricing_schema, product.unit)} />
      </Box>
      <TableCard.TextWithTagChip
        label='Status'
        kind={product.status === 'active' ? 'success' : 'default'}
        value={product.status === 'active' ? 'Ativo' : 'Inativo'}
      />
    </TableCard.Container>
  );
};

function TableCardProducts() {
  const { listing } = useFilter();
  const { isLoading, data } = listing.query;

  if (isLoading) {
    return null;
  }

  return (
    <Filter.FilterProvider {...listing}>
      <Box display='flex' flexDirection='column' gridGap='16px'>
        {data?.products?.map((product) => (
          <ProductItem key={product.id} product={product} />
        ))}
      </Box>
      <Filter.Pagination />
    </Filter.FilterProvider>
  );
}

export default TableCardProducts;
